export default __webpack_public_path__ + "static/media/close_skill.846dc60d.svg";